import { useLang } from "@/i18n/LanguageContext";

export default function Industries() {
  const { t } = useLang();
  // Duplicate items for seamless marquee
  const items = [...t.industries.items, ...t.industries.items];
  return (
    <section id="industries" className="py-20 lg:py-24 bg-[#0B132B] text-white overflow-hidden relative" data-testid="industries-section">
      <div className="absolute inset-0 bbm-grid-bg-dark opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 mb-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <p className="bbm-eyebrow !text-[#FFB800] mb-4">— {t.industries.eyebrow}</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight">
              {t.industries.title}
            </h2>
          </div>
        </div>
      </div>

      <div className="relative">
        <div className="bbm-marquee">
          {items.map((label, i) => (
            <div
              key={i}
              className="flex items-center gap-4 ps-4"
              data-testid={`industry-${i}`}
            >
              <span className="w-2 h-2 rotate-45 bg-[#FFB800]" />
              <span className="font-display text-3xl lg:text-5xl text-white whitespace-nowrap">
                {label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
